<template>
  <div v-if="images" class="site-gallery">
    <div class="site-gallery-tiles">
      <site-carousel
        v-if="isMobile"
        :items="carouselImages"
        :slide.sync="imageToViewIndex"
        :is-listing-view="isListingView"
        easy
        tile
        load-all
        @slide-change="currentSlide = $event"
      />
      <v-row class="d-none d-sm-flex" no-gutters>
        <div style="flex: 1.215">
          <v-img
            class="site-gallery-item rounded-lg"
            :src="mainImage"
            @click="openViewDialog(0)"
            aspect-ratio="1.6"
          />
        </div>
        <div v-if="tileImages.length" style="flex: 1">
          <v-row
            no-gutters
            :class="{
              'fill-height':
                tileImages.length >
                (isIPad || isLaptop || isLargeLaptop ? 3 : 4),
            }"
          >
            <v-col
              v-for="(item, index) in tileImages"
              :key="`tile-${index}`"
              cols="6"
              :class="[
                {
                  'pb-3':
                    index <= (isIPad || isLaptop || isLargeLaptop ? 1 : 2),
                },
                'pl-3',
              ]"
            >
              <v-img
                class="site-gallery-item rounded-lg"
                :src="item"
                @click="openViewDialog(index + 1)"
                aspect-ratio="1.3"
              />
            </v-col>
          </v-row>
        </div>
      </v-row>
    </div>
    <div v-show="count" class="site-gallery-count">
      <span class="d-sm-none" v-text="currentSlide" />
      <span class="d-sm-none mx-1">/</span>
      <span v-text="images.length" />
    </div>
    <v-dialog v-model="viewDialog" content-class="elevation-0" max-width="1100">
      <site-carousel
        :items="carouselImages"
        :slide.sync="imageToViewIndex"
        easy
        easy-contain
        :show-dots="carouselImages.length < 20"
        @slide-change="currentSlide = $event + 1"
      />
    </v-dialog>
  </div>
</template>

<script>
import DeviceMixin from "@/mixins/device-mixin";
import SiteCarousel from "@/components/common/carousel/site-carousel";
export default {
  name: "site-gallery",
  components: { SiteCarousel },
  mixins: [DeviceMixin],
  props: {
    images: {
      type: Array,
    },
    simple: {
      type: Boolean,
      default: false,
    },
    aspectRatio: {
      type: [String, Number],
      default: "1",
    },
    count: {
      type: Boolean,
      default: false,
    },
    xs: {
      type: String,
      default: "12",
    },
    sm: {
      type: String,
      default: "4",
    },
    md: {
      type: String,
      default: "3",
    },
    lg: {
      type: String,
      default: "3",
    },
    xl: {
      type: String,
      default: "2",
    },
    isListingView: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({ viewDialog: false, imageToViewIndex: 0, currentSlide: 1 }),
  computed: {
    mainImage() {
      return this.images[0].original.replace("upload/", "upload/c_fit,h_900/");
    },
    tileImages() {
      return this.images
        .slice(1, this.isIPad || this.isLaptop || this.isLargeLaptop ? 5 : 5)
        .map((i) => i.original.replace("upload/", "upload/c_fit,h_600/"));
    },
    thumbnails() {
      return this.images.map((pic) => pic.thumbnail || pic.original);
    },
    carouselImages() {
      return this.images.map(
        (i) =>
          i.original.replace("upload/", "upload/c_fit,h_900/") || i.thumbnail
      );
    },
  },
  methods: {
    openViewDialog(imageIndex) {
      this.imageToViewIndex = imageIndex;
      this.currentSlide = imageIndex + 1;
      this.viewDialog = true;
    },
  },
  watch: {
    imageToViewIndex(val) {
      this.currentSlide = val + 1;
    },
  },
};
</script>

<style lang="scss">
.site-gallery {
  position: relative;
  -webkit-overflow-scrolling: touch;
  overflow: hidden;
  &-item {
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none;
    user-select: none;
  }
  &-count {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(map-get($grey, "darken-4"), 0.5);
    width: 60px;
    height: 30px;
    color: #fff;
    border-radius: 7px;
    bottom: 20px;
    right: 20px;
    z-index: 1;
  }
}
</style>
